export default __webpack_public_path__ + "static/partner16-37d8e3f49743c60c7ac689215e35e93a.jpg";